import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["classes"];
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { default as withStyles } from '../styles';
import { default as MuiCardActions } from '@material-ui/core/CardActions';
import getLegacySpacingModeCss from './internal/getLegacySpacingModeCss';
import { CardContext } from './Card';
import classNames from 'classnames';
import { spacing40, spacing30 } from '../styles/tokens';

var styles = function styles(theme) {
  var _responsive;

  return {
    root: {},
    standard: {
      padding: spacing40
    },
    dense: {
      padding: "0.75rem " + spacing30
    },
    none: {
      padding: 0
    },
    responsive: (_responsive = {}, _responsive[theme.breakpoints.only('xs')] = {
      padding: spacing30 + " 0"
    }, _responsive)
  };
};
/**
 * CardActions component for displaying actions on a Card component
 */


var CardActions = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var classes = props.classes,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var classesOverrides = getLegacySpacingModeCss(useContext(CardContext), classes);
  var classOverrides = {
    root: classNames(classes.root, classesOverrides)
  };
  return /*#__PURE__*/React.createElement(MuiCardActions, _extends({}, rest, {
    classes: classOverrides,
    ref: ref
  }));
});
CardActions.muiName = 'CardActions';
CardActions.displayName = 'CardActions';
CardActions.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the card actions do not have additional margin.
   */
  disableSpacing: PropTypes.bool
}; // If default props are needed, they must be set here

CardActions.defaultProps = {
  disableSpacing: false
};
export default withStyles(styles)(CardActions);